import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Label } from 'jbc-front/components/presenters/form/Label';
import { Textarea } from 'jbc-front/components/presenters/form/Textarea';
import { Radio, RadioContainer } from 'jbc-front/components/presenters/form/Radio';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { AnchorTarget } from '@/components/AnchorTarget';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import type { Schema } from '../../schema';

export const Urine: FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<Schema>();
  const sugarItemErrors = errors.items?.urineSugar;
  const proteinItemErrors = errors.items?.urineProtein;

  return (
    <Panel>
      <Headding>尿検査</Headding>
      <Item>
        <Panel>
          <AnchorTarget name="urine_sugar" />
          <Headding>糖</Headding>
          <Item>
            <div>
              <Label>実施有無</Label>
              <Spacer size={8} />
              <RadioContainer>
                <Radio {...register('items.urineSugar.checked')} value="true">
                  実施
                </Radio>
                <Radio {...register('items.urineSugar.checked')} value="false">
                  未実施
                </Radio>
              </RadioContainer>
              {sugarItemErrors?.checked?.message && <ErrorMessage>{sugarItemErrors.checked.message}</ErrorMessage>}
            </div>
            <div className="u-mt20">
              <Label>結果</Label>
              <Spacer size={8} />
              <Textarea {...register('items.urineSugar.value')} rows={3} isError={!!sugarItemErrors?.value} />
              {sugarItemErrors?.value?.message && <ErrorMessage>{sugarItemErrors.value.message}</ErrorMessage>}
            </div>
            <div className="u-mt20">
              <Label>評価</Label>
              <Spacer size={8} />
              <Textarea {...register('items.urineSugar.evaluation')} rows={3} isError={!!sugarItemErrors?.evaluation} />
              {sugarItemErrors?.evaluation?.message && (
                <ErrorMessage>{sugarItemErrors.evaluation.message}</ErrorMessage>
              )}
            </div>
            <div className="u-mt20">
              <Label>所見有無</Label>
              <Spacer size={8} />
              <RadioContainer>
                <Radio {...register('items.urineSugar.hasFinding')} value="false">
                  所見なし
                </Radio>
                <Radio {...register('items.urineSugar.hasFinding')} value="true">
                  所見あり
                </Radio>
              </RadioContainer>
              {sugarItemErrors?.hasFinding?.message && (
                <ErrorMessage>{sugarItemErrors.hasFinding.message}</ErrorMessage>
              )}
            </div>
          </Item>
        </Panel>
        <Panel className="u-mb0">
          <AnchorTarget name="urine_protein" />
          <Headding>蛋白</Headding>
          <Item>
            <div>
              <Label>実施有無</Label>
              <Spacer size={8} />
              <RadioContainer>
                <Radio {...register('items.urineProtein.checked')} value="true">
                  実施
                </Radio>
                <Radio {...register('items.urineProtein.checked')} value="false">
                  未実施
                </Radio>
              </RadioContainer>
              {proteinItemErrors?.checked?.message && <ErrorMessage>{proteinItemErrors.checked.message}</ErrorMessage>}
            </div>
            <div className="u-mt20">
              <Label>結果</Label>
              <Spacer size={8} />
              <Textarea {...register('items.urineProtein.value')} rows={3} isError={!!proteinItemErrors?.value} />
              {proteinItemErrors?.value?.message && <ErrorMessage>{proteinItemErrors.value.message}</ErrorMessage>}
            </div>
            <div className="u-mt20">
              <Label>評価</Label>
              <Spacer size={8} />
              <Textarea
                {...register('items.urineProtein.evaluation')}
                rows={3}
                isError={!!proteinItemErrors?.evaluation}
              />
              {proteinItemErrors?.evaluation?.message && (
                <ErrorMessage>{proteinItemErrors.evaluation.message}</ErrorMessage>
              )}
            </div>
            <div className="u-mt20">
              <Label>所見有無</Label>
              <Spacer size={8} />
              <RadioContainer>
                <Radio {...register('items.urineProtein.hasFinding')} value="false">
                  所見なし
                </Radio>
                <Radio {...register('items.urineProtein.hasFinding')} value="true">
                  所見あり
                </Radio>
              </RadioContainer>
              {proteinItemErrors?.hasFinding?.message && (
                <ErrorMessage>{proteinItemErrors.hasFinding.message}</ErrorMessage>
              )}
            </div>
          </Item>
        </Panel>
      </Item>
    </Panel>
  );
};
